/**
 * Types for admin home groups feature.
 */

export type DayOfWeek =
  | "MONDAY"
  | "TUESDAY"
  | "WEDNESDAY"
  | "THURSDAY"
  | "FRIDAY"
  | "SATURDAY"
  | "SUNDAY";

export interface AdminAccountRef {
  id: string;
  firstName: string | null;
  lastName: string | null;
  username: string | null;
  telegramId?: string | null;
}

export interface HomeGroupScheduleItem {
  id: string;
  dayOfWeek: DayOfWeek;
  startTime: string;
  endTime: string | null;
  isActive: boolean;
}

export interface AdminHomeGroupListItem {
  id: string;
  name: string;
  description: string | null;
  location: string | null;
  isActive: boolean;
  isOpen: boolean;
  leader: AdminAccountRef | null;
  coLeader: AdminAccountRef | null;
  schedules: HomeGroupScheduleItem[];
  memberCount: number;
}

export interface AdminHomeGroupsFilter {
  isActive?: boolean;
  isOpen?: boolean;
}

export const DAY_OF_WEEK_LABELS: Record<DayOfWeek, string> = {
  MONDAY: "Пн",
  TUESDAY: "Вт",
  WEDNESDAY: "Ср",
  THURSDAY: "Чт",
  FRIDAY: "Пт",
  SATURDAY: "Сб",
  SUNDAY: "Вс",
};

export function formatAccountName(account: AdminAccountRef): string {
  const parts = [account.firstName, account.lastName].filter(Boolean);
  if (parts.length) return parts.join(" ");
  return account.username || account.id.slice(0, 8);
}
